import * as React from "react";
import {Router, Switch, Route} from "react-router-dom";
import {inject, observer} from "mobx-react";
import FormikResetPassword from "@components/ResetPassword/FormikResetPassword";
import Login from "@templates/login";


@inject("store")
@observer
export default class Account extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {


        return (
            <div className="site-selector">
                <div className="site-selector-background" style={{backgroundImage: "url('')"}}></div>
                <div style={{display: "flex", width: "100%", height: "100%", justifyContent: "center"}}>
                    <div style={{width: 600, margin: "auto 15px"}}>
                        <div className="row">
                            <div className="col-12">
                                <Switch>
                                    <Route path="/resetpassword" render={() =>
                                        <Login/>
                                    }/>
                                    <Route>
                                        <FormikResetPassword/>
                                    </Route>

                                </Switch>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


        );
    }
}

